import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EventsService, UtilService, VariablesService, VwoService } from 'src/app/shared/services';

@Component({
  selector: 'app-story-img-slider',
  templateUrl: './story-img-slider.component.html',
  styleUrls: ['./story-img-slider.component.scss']
})
export class StoryImgSliderComponent {

  @Input() gallery;
  @Input() basicInfo;
  @Input() shadow;
  @Input() fundraiser;
  @Input() slideType;
  isMobile;
  autoSlide;

  constructor(
    public util: UtilService,
    public domSanitizer: DomSanitizer,
    public vwo: VwoService,
    public vars: VariablesService,
    private events: EventsService
  ) { }

  ngOnInit() {    
    this.isMobile = this.util.isMobile();
    this.autoSlide = this.gallery?.length > 1 ? true : false;
    if (this.util.isBrowser) {
      setTimeout(() => {
        const arrows = document.getElementsByClassName('glide__arrow');
        for (let i = 0; i < arrows.length; i++) {
          arrows[i].addEventListener('click', () => {
            this.autoSlide = false;
          });
        }
      }, 1000);
    }
  }

  trackByFn(index, item) {
    return item.id; // Ensure the same DOM element persists
  }

  toggleBlur() {
    this.vars.blur_image = !this.vars.blur_image;
    const ePayload = {
      eventName: 'story_blur_images',
      info_1: this.vars.blur_image ? "ON" : "OFF"
    }; 
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }

  addYoutubeEmbed(slide) {
    const id = this.util.getYouTubeId(slide.path);
    slide.videoSrc = this.domSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
    slide.showVideo = true;
  }

}
